// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"e1eeb5ea","106":"0aa8247e","124":"f3112ba8","131":"b24ceb25","154":"8713a435","241":"c0b4cb15","286":"a192ba60","287":"8a8477e2","418":"884a8bb4","680":"f7dbe224","691":"45893264","854":"7e91153c"}[chunkId] + ".chunk.js";
};